import './search-result-item-card.scss'

import { defineComponent, PropType } from 'vue';
import { TranslateResult } from 'vue-i18n'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SearchResult } from "@skinsoft/types";
import { searchResultSelectors } from "@skinsoft/search-data-store";
import { itemTypeFormatters } from "@skinsoft/entity/src/item";

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { Touchable } from "../touchable";
import { Media } from "../item-card/media";
import { Description } from "../item-card/description";
import { Location } from '../item-card/location'

export const SearchResultItemCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sTouchable: Touchable,
        sMedia: Media,
        sDescription: Description,
        sLocation: Location,
    },
    props: {
        focused: {
            required: false,
        },
        item: {
            type: Object as PropType<SearchResult>,
            required: true,
        },
        readonly: {
            default: false,
            required: false,
        },
        displayType: {
            required: false
        }
    },
    template: require('./search-result-item-card.html'),
    data() {
        return {
            contentReady: false,
            encounteredError: false,
            validated: false,
            loadingIcon: faCircleNotch,
            searchResultSelectors,
            descriptionReady: false,
            locationReady: false,
        }
    },
    computed: {
        readableCardType(): TranslateResult {
            return this.$t(itemTypeFormatters.getReadableType(searchResultSelectors.itemType(this.item) ?? ''))
        },
    },
    methods: {
        onDescriptionReady() {
            this.descriptionReady = true;
            this.processContentReady();
        },
        onLocationReady() {
            this.locationReady = true;
            this.processContentReady();
        },
        processContentReady() {
            this.contentReady = this.descriptionReady && this.locationReady;
        },
    },
})
